<header class="header" id="header">
  <nav class="navbar navbar-expand-lg header-nav">
    <div class="header-nav__left">
      <!-- Mobile menu button -->
      <button
        type="button"
        class="header-menu-btn d-inline-flex d-lg-none"
        (click)="onMenuClick()"
        aria-label="Abrir menú">
        <hugeicons-icon [icon]="Menu01Icon" [size]="32" color="#0a6d37" [strokeWidth]="2"></hugeicons-icon>
      </button>
    </div>

    <div class="header-nav__right" *ngIf="showProfile && !showTerminos">
      <!-- Notifications -->
      <button
        type="button"
        class="header-icon-btn"
        (click)="gotoMessageList()"
        aria-label="Mensajes">
        <hugeicons-icon [icon]="Notification01Icon" [size]="24" [strokeWidth]="2"></hugeicons-icon>
        <span class="header-badge" *ngIf="(newMessageList$ | async)?.length as count">
          {{ count }}
        </span>
        <span class="header-badge" *ngIf="(newMessageList$ | async) == null">0</span>
      </button>

      <!-- Account dropdown -->
      <div class="dropdown account-dropdown">
        <button
          class="account-dropdown__toggle"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false">

          <span class="user-img" *ngIf="!profileImage && personalDataNombreCompleto">
            <ngx-avatars size="42" [name]="personalDataNombreCompleto"></ngx-avatars>
          </span>

          <span class="user-img" *ngIf="!profileImage && !personalDataNombreCompleto">
            <img src="assets/img/img-04.jpg" alt="User" />
          </span>

          <span class="user-img" *ngIf="profileImage">
            <img [src]="profileImage" alt="Profile" />
          </span>

          <span class="account-dropdown__name d-none d-md-inline">
            {{ (userInfo$ | async)?.data?.accountName }}
          </span>

          <hugeicons-icon [icon]="ArrowDown01Icon" color="#374151" [size]="20" [strokeWidth]="2"></hugeicons-icon>
        </button>

        <div class="dropdown-menu dropdown-menu-end emp">
          <div class="drop-head">Cuenta</div>
          <button class="dropdown-item" type="button" (click)="gotoAccount()">
            <hugeicons-icon [icon]="AccountSetting01Icon" color="#374151" [size]="20" [strokeWidth]="2"></hugeicons-icon>
            Mi cuenta
          </button>
          <button class="dropdown-item" type="button" (click)="logout()">
            <hugeicons-icon [icon]="LogoutSquare02Icon" color="#374151" [size]="20" [strokeWidth]="2" class="nav-icon"></hugeicons-icon>
            Salir
          </button>
        </div>
      </div>
    </div>
  </nav>
</header>